import { Action, Reducer } from 'redux';
import { ACTION } from './action-types';
import * as actions from './action-types';
import { FavouriteInstanceState, FavouriteState } from './types-store';

const INITIAL_STATE: FavouriteState = {
  instances: {},
  texts: {} as any
};

const INITIAL_INSTANCE_STATE: FavouriteInstanceState = {
  fetchingReportCategory: false,
  reportCategory: undefined,
  fetchingSortOptions: false,
  sortOptions: undefined,
  fetchingDefinition: false,
  definition: undefined,
  workingDefinition: undefined,
  searchRequiredUsers: undefined,
  urlMultipleSuppliers: undefined,
  validateFilters: undefined
};

const instanceReducers: {
  [indexer: string]: Reducer<FavouriteInstanceState, Action>;
} = {
  /**
   * Run when search query value is cleared
   */
  [ACTION.CLEAR_RESULTS]: (
    state: FavouriteInstanceState,
    action: actions.ClearResults
  ): FavouriteInstanceState => {
    return {
      ...state,
      fetchingSortOptions: false,
      sortOptions: undefined,
      fetchingDefinition: false,
      definition: undefined,
      workingDefinition: undefined
    };
  },

  [ACTION.REQUEST_REPORT_CATEGORY]: (
    state: FavouriteInstanceState,
    action: actions.RequestReportCategory
  ): FavouriteInstanceState => {
    return {
      ...state,
      fetchingReportCategory: true,
      reportCategory: undefined
    };
  },

  [ACTION.RECEIVE_REPORT_CATEGORY]: (
    state: FavouriteInstanceState,
    action: actions.ReceiveReportCategory
  ): FavouriteInstanceState => {
    return {
      ...state,
      fetchingReportCategory: false,
      reportCategory: action.data
    };
  },

  [ACTION.REQUEST_SORT_OPTIONS]: (
    state: FavouriteInstanceState,
    action: actions.RequestSortOptions
  ): FavouriteInstanceState => {
    return {
      ...state,
      fetchingSortOptions: true
    };
  },

  [ACTION.RECEIVE_SORT_OPTIONS]: (
    state: FavouriteInstanceState,
    action: actions.ReceiveSortOptions
  ): FavouriteInstanceState => {
    return {
      ...state,
      fetchingSortOptions: false,
      sortOptions: action.options
    };
  },

  /**
   * Run when starting fetching definition data for a case report favourite.
   */
  [ACTION.REQUEST_FAVOURITE_DEFINITION]: (
    state: FavouriteInstanceState,
    action: actions.RequestFavouriteDefinition
  ): FavouriteInstanceState => {
    return {
      ...state,
      fetchingDefinition: true,
      definition: undefined,
      workingDefinition: undefined
    };
  },

  [ACTION.RECEIVE_FAVOURITE_DEFINITION]: (
    state: FavouriteInstanceState,
    action: actions.ReceiveFavouriteDefinition
  ): FavouriteInstanceState => {
    return {
      ...state,
      definition: action.definition,
      workingDefinition: action.definition,
      fetchingDefinition: false
    };
  },

  [ACTION.UPDATE_WORKING_DEFINITION]: (
    state: FavouriteInstanceState,
    action: actions.ReceiveFavouriteDefinition
  ): FavouriteInstanceState => {
    return {
      ...state,
      workingDefinition: action.definition
    };
  },

  [ACTION.LOAD_FAVOURITE_DEFINITION_FAILURE]: (
    state: FavouriteInstanceState,
    action: actions.LoadFavouriteDefinitionFailure
  ): FavouriteInstanceState => {
    return {
      ...state,
      ...INITIAL_INSTANCE_STATE
    };
  },

  [ACTION.RECEIVE_URL_MULTIPLE_SUPPLIERS]: (
    state: FavouriteInstanceState,
    action: actions.ReceiveUrlMultipleSuppliers
  ): FavouriteInstanceState => {
    return {
      ...state,
      urlMultipleSuppliers: action.urlMultipleSuppliers
    };
  },

  [ACTION.RECEIVE_SEARCH_REQUIRED_USERS]: (
    state: FavouriteInstanceState,
    action: actions.ReceiveSearchRequiredUsers
  ): FavouriteInstanceState => {
    return {
      ...state,
      searchRequiredUsers: action.searchRequiredUsers
    };
  },
    
  [ACTION.CREATE_FAVOURITE_DEFINITION_FAILURE]: (
    state: FavouriteInstanceState,
    action: actions.CreateFavouriteDefinitionFailure
  ): FavouriteInstanceState => {
    return {
      ...state,
      ...INITIAL_INSTANCE_STATE
    };
  },

  [ACTION.VALIDATE_FAVOURITE_FILTERS]: (
    state: FavouriteInstanceState, 
    action: actions.ValidateFavouriteFilters
  ): FavouriteInstanceState => {
    return {
      ...state,      
      validateFilters: true
    };
  }
};

const topLevelReducers: {
  [indexer: string]: Reducer<FavouriteState, Action>;
} = {
  [ACTION.ADD_INSTANCE]: (state: FavouriteState, action: actions.AddInstance): FavouriteState => {
    return {
      ...state,
      instances: {
        ...state.instances,
        [action.instanceKey]: {
          ...INITIAL_INSTANCE_STATE
        }
      }
    };
  },
  [ACTION.CLEAR_INSTANCE]: (state: FavouriteState, action: actions.ClearInstance): FavouriteState => {
    return {
      ...state,
      instances: Object.keys(state.instances).filter(i => i !== action.instanceKey).reduce(
        (aggr, i) => {
          aggr[i] = state.instances[i];
          return aggr;
        }, {})
    };
  }
};

export const reducer: Reducer<FavouriteState> = (
  state: FavouriteState = INITIAL_STATE,
  action: any
) => {
  if (topLevelReducers[action.type]) {
    return topLevelReducers[action.type](state, action);
  }
  else if (instanceReducers[action.type] && action.instanceKey) {
    return {
      ...state,
      instances: {
        ...state.instances,
        [action.instanceKey]: {
          ...instanceReducers[action.type](
            state.instances?.[action.instanceKey],
            action
          )
        }
      }
    };
  }
  return state;
};
